//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import FastQuery from "@/0/components/comForm/comFormIndex/comFormIndexFastQuery";
import FormQuery from "@/0/components/comForm/comFormIndex/comIndexFormQuery.vue";
import FormOperateList from "@/0/components/comForm/comOperateList/comFormOperateList2.vue";

export default {
  components: {
    "page-header": PageHeader,
    "fast-query": FastQuery,
    "form-query": FormQuery,
    "form-operate-list": FormOperateList
  },

  async created(){

    var oaOpenId = "225a333b35c96e744552faa68baad896";
    await this.$wx.initOaConfig(oaOpenId, () => {
      console.log("初始化成功");
    });

  },
  
  data() {
    return {

      dataConfig: {
        Form:{
          Url : "/mTplApi/TemplateButton/GetIndexForm",
        }
      },
      
      isFormInit: false,
      isFormShow: true,
      headerConfig: {
        Title: "创建表单"
      },

      formItem: null,
      fastQueryConfig: {
        text: "请输入搜索内容",
        QueryValue: ""
      },

      queryCondition: {},

      operateListConfig: {
        ButtonList: []
      }
    };
  },

  async mounted() {
    await this.initForm();
  },

  methods: {

    $getSubmitData(){

      var formData = {};
      formData["aaa"] = "111111111111";
      formData["bbb"] = "bbbbbbbbbbbb";
      //console.log("$getSubmitData",formData);
      return formData;
    },

    getFormViewUrl() {
      var url = this.dataConfig.Form.Url;
      return url;
    },

    async initForm() {
      this.isFormInit = false;
      this.$msg.showLoading("正在获取...");

      var url = this.getFormViewUrl();
      var result = await this.$web.post(url);
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.isFormInit = true;
        this.formItem = result.data;
        var resultData = result.data;

        this.$msg.succ("加载完成");

        this.headerConfig.Title = resultData.Title;
        this.queryCondition = resultData.QueryCondition;
        console.log("this.queryCondition", this.queryCondition);

        setTimeout(() => {
          var $comFormOperateList = this.$refs.comFormOperateList;
          if($comFormOperateList){
            $comFormOperateList.setData(resultData.OperateList);
          }
        }, 0);
        return;
      }
      this.$msg.alert(result.msg);
    },

    $refreshForm() {
      console.log("$refreshForm");
      this.$msg.succ("数据已经刷新");
    }
  }
};
